module.exports = __webpack_public_path__ + "2c9248b503b37c426752dbefd8dd8ae8.MP3";